// @flow

import initialState from "./commonInitialState";

import serverReducer from "./serverReducer";
import magReducer from "./magReducer";
import clientReducer from "./clientReducer";
import profilesReducer from "./profilesReducer";
import statsReducer from "./statsReducer";
import profileSetReducer from "./profileSetReducer";
import magTypeReducer from "./magTypeReducer";
import sampleTypeReducer from "./sampleTypeReducer";
import deviceStatusReducer from "./deviceStatusReducer";
import syncLogReducer from "./syncLogReducer";
import remoteUserInfoReducer from "./remoteUserReducer";

// this combines the state from each of the COMMON reducers into our COMMON initial state
// NOTE: we remap the reducers to their better known names in the larger
// state object here.
export function commonAppReducer(state = initialState, ourClientId:number, action) {
    const updatedState = {
        serverInfo: serverReducer(state.serverInfo,ourClientId,action),
        magInfo: magReducer(state.magInfo, ourClientId,action),
        clientInfo: clientReducer(state.clientInfo, ourClientId,action),
        profiles: profilesReducer(state.profiles, ourClientId, action),
        statsInfo: statsReducer(state.statsInfo, ourClientId, action),
        profileSet: profileSetReducer(state.profileSet, ourClientId, action),
        magTypes: magTypeReducer(state.magTypes, ourClientId, action),
        sampleTypes: sampleTypeReducer(state.sampleTypes,ourClientId,  action),
        device: deviceStatusReducer(state.device, ourClientId, action),
        syncLog: syncLogReducer(state.syncLog, ourClientId, action),
        remoteUserInfo: remoteUserInfoReducer(state.remoteUserInfo, ourClientId, action),

    };
    return {...state,...updatedState};
}
